import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { useLanguage } from "../../i18n/LanguageContext";

const RegistrationsChart = ({ data, authBreakdown }) => {
  const { t } = useLanguage();
  return (
    <Card className="border border-border">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">{t("platform.registrations")}</CardTitle>
          {authBreakdown && (
            <div className="flex gap-3 text-xs text-muted-foreground">
              <span>Email: {authBreakdown.email}</span>
              <span>{t("platform.yandex")}: {authBreakdown.yandex}</span>
              <span>Google: {authBreakdown.google}</span>
            </div>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {data && data.length > 0 ? (
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={(d) => d.slice(5)} stroke="hsl(var(--muted-foreground))" />
              <YAxis tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" allowDecimals={false} />
              <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
              <Bar dataKey="value" fill="#C9963B" radius={[4, 4, 0, 0]} name={t("platform.registrationsBar")} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[180px] flex items-center justify-center text-sm text-muted-foreground">
            {t("platform.noData")}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RegistrationsChart;
